import React from "react";
import Card from "components/card";
import Badge from "components/badge/Badge";
import { formatNumber } from "utils/format";
import SliderDistributionCard from "./SliderDistributionCard";
import ChoiceDistributionCard from "./ChoiceDistributionCard";
import TextResponsesCard from "./TextResponsesCard";
import {
  getQuestionTypeMeta,
  isChoiceQuestion,
  isNumericQuestion,
  isTextQuestion,
} from "./questionTypes";

const QuestionDetail = ({
  question,
  textResponses = [],
  loadingTextResponses = false,
  searchQuery = "",
  onSearchChange,
  sortOrder = "newest",
  onSortChange,
  onGenerateAISummary,
  isGeneratingSummary = false,
}) => {
  if (!question) {
    return null;
  }

  const { type, questionText, stats, options } = question;
  const typeInfo = getQuestionTypeMeta(type);
  const TypeIcon = typeInfo.icon;

  return (
    <div className="flex flex-col gap-5">
      <Card padding="md">
        <Badge tone="brand" className="self-start">
          <TypeIcon aria-hidden="true" className="h-4 w-4" />
          {typeInfo.label}
        </Badge>
        <h3 className="text-heading mt-2">{questionText}</h3>
        <p className="mt-1 text-sm text-fg-muted">
          {formatNumber(stats?.count || 0)} responses
          {typeInfo.description && ` • ${typeInfo.description}`}
        </p>
      </Card>

      {isNumericQuestion(type) && <SliderDistributionCard stats={stats} />}

      {isChoiceQuestion(type) && (
        <ChoiceDistributionCard
          type={type}
          options={options}
          distribution={stats?.distribution}
          totalResponses={stats?.count || 0}
        />
      )}

      {isTextQuestion(type) && (
        <TextResponsesCard
          responses={textResponses}
          loading={loadingTextResponses}
          stats={stats}
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          sortOrder={sortOrder}
          onSortChange={onSortChange}
          onGenerateAISummary={onGenerateAISummary}
          isGeneratingSummary={isGeneratingSummary}
        />
      )}
    </div>
  );
};

export default QuestionDetail;
